var nameRegex = /.*/;
export default nameRegex;